import React, { useEffect, useState } from "react";
import logo from "../../../assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getGoogleVerificationCodeByDomainAction,
  getStoresBasedOnDomainAction,
} from "../../../redux/actions";
import { getCouponListByNameAction } from "../../../redux/actions";
import { getStoresByNameAction } from "../../../redux/stores/actions";
import "../../../assets/css/home2v2.css";

import { Link } from "react-router-dom";
import { getImageUrl } from "../../../utils";

const Header = () => {
  const dispatch = useDispatch();

  const { domainData } = useSelector((state) => state.Website);

  useEffect(() => {
    function fetch() {
      dispatch(getStoresBasedOnDomainAction());
    }
    fetch();
  }, [dispatch]);

  useEffect(() => {
    dispatch(getGoogleVerificationCodeByDomainAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  const [searchValue, setSearchValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleSearch = () => {
    dispatch(getCouponListByNameAction({ name: searchValue }));
    dispatch(getStoresByNameAction({ name: searchValue }));
    enterSearch.current.click();
  };

  const handleNavOptionClick = () => {
    setIsOpen(false);
  }

  const enterSearch = React.useRef();

  return (
    <>
      <nav
        id="navbar"
        className="navbar"
        style={{
          background: domainData?.header_color,
        }}
      >
        <div
          id="navbar-container"
          className="container"
        >
          <div id="navbar-header" className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              id="navbar-toggle-button"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="sr-only">Toggle navigation</span>{" "}
              {isOpen ? (
                <i className="fa-solid fa-x"></i>
              ) : (
                <i className="fa-solid fa-bars"></i>
              )}
            </button>
            {domainData?.logo ? (
              <Link to="/">
                <img
                  src={getImageUrl(domainData?.logo, logo)}
                  alt=""
                  id="navbar-logo"
                />
              </Link>
            ) : (
              " "
            )}{" "}
          </div>
          <div
            id="navbar-search-section"
          >
            <div
              id="search-input-wrapper"
            >
              <input
                type="text"
                id="navbar-search-input"
                placeholder="What are you looking for?"
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSearch();
                  }
                }}
                value={searchValue}
              />
              <Link to="/searchpage">
                <button
                  type="submit"
                  className="searchButton"
                  id="navbar-search-button"
                  ref={enterSearch}
                  onClick={handleSearch}
                >
                  <i className="fa fa-search"></i>
                </button>
              </Link>
            </div>
            <button
              id="navbar-all-stores-button"
            >
              <Link to="store">
                All Stores
              </Link>
            </button>
          </div>
        </div>

        <div
          className="container"
          id="mobile-nav-container"
        >
          <div className="navbar-header" id="hide-navbar-on-mobile">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              onClick={() => setIsOpen(!isOpen)}
            >
              {" "}
              <span className="sr-only">Toggle navigation</span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
              <span className="icon-bar"></span>{" "}
            </button>{" "}
          </div>

          <div id="desktop-hidden-nav" className={isOpen ? "mobile-nav-show" : "mobile-nav-hidden"}>
            <ul
              id="mobile-nav-list"
            >
              <li onClick={handleNavOptionClick} >
                <Link to="/" >
                  Home
                </Link>
              </li>
              <li onClick={handleNavOptionClick}i>
                <Link to="/store" >
                  Stores
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/aboutus" >
                  About us
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/categories" >
                  Categories
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/contactus" >
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
          
          <div id="mobile-hidden-nav">
            <ul
              id="mobile-nav-list"
            >
              <li onClick={handleNavOptionClick} >
                <Link to="/" >
                  Home
                </Link>
              </li>
              <li onClick={handleNavOptionClick}i>
                <Link to="/store" >
                  Stores
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/aboutus" >
                  About us
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/categories" >
                  Categories
                </Link>
              </li>
              <li onClick={handleNavOptionClick}>
                <Link to="/contactus" >
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
